/**
 * Wraps window.location navigation methods so they can be mocked in unit tests.
 * window.location properties are non-configurable in JSDOM, making direct mocking impossible.
 */

export function navigateTo(url) {
  window.location.assign(url);
}

export function replaceLocation(url) {
  window.location.replace(url);
}

export function getLocationOrigin() {
  return window.location.origin;
}

export function setLocationHref(url) {
  window.location.href = url;
}

export function getLocationHash() {
  return window.location.hash;
}

export function reloadLocation() {
  window.location.reload();
}

export function getLocationHostname() {
  return window.location.hostname;
}
